module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-content",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "account-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requireLogin),
      expression: "requireLogin"
    }],
    staticClass: "slogan-wrapper"
  }, [_c('span', {
    staticClass: "slogan-text"
  }, [_vm._v(_vm._s(_vm.$t("index.loginText")))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requireLogin),
      expression: "requireLogin"
    }],
    staticClass: "account-form"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-input",
    class: {
      'input-require': _vm.nameValidate.invalidate
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('index.userName')
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.nameValidate.emtpy) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t("index. userTip")))]) : _vm._e(), _vm._v(" "), (_vm.nameValidate.format) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t("index. errorFormat")))]) : _vm._e(), _vm._v(" "), (_vm.nameValidate.active) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t("index. inactive")) + " "), _c('span', {
    staticClass: "resend",
    on: {
      "click": _vm.resend
    }
  }, [_vm._v(_vm._s(_vm.$t("index. resend")))]), _vm._v(" "), (_vm.reSend.success) ? _c('span', [_vm._v(_vm._s(_vm.$t("index. success")))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-input",
    class: {
      'input-require': _vm.pwdValidate.invalidate
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('index.password')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.pwdValidate.emtpy) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t("index. pwdTip")))]) : _vm._e(), _vm._v(" "), (_vm.loginResult.fail) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t("index. loginFail")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-row btn-wrap"
  }, [_c('button', {
    staticClass: "czur-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t("index.loginText")))])]), _vm._v(" "), _c('div', {
    staticClass: "register-row"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "forget-password",
    on: {
      "click": _vm.findPwd
    }
  }, [_vm._v(_vm._s(_vm.$t("index.forgetPwd")))]), _vm._v(" "), _c('li', {
    staticClass: "user-register",
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t("index.register")))])])])]), _vm._v(" "), _c('loading', {
    attrs: {
      "appear": _vm.processing
    }
  }), _vm._v(" "), _c('LoginCheck', {
    on: {
      "nologin": _vm.withOutLogin,
      "islogin": _vm.alreadyLogin
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logout-frame"
  }, _vm._l((_vm.logoutAPIs), function(api) {
    return _c('iframe', {
      attrs: {
        "src": api,
        "frameborder": "0"
      }
    })
  }), 0)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-550244e1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-550244e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 161
// module chunks = 2 3